<template>
  <UIPreloader :message class="main-loader" />
</template>

<script setup lang="ts">
import { UIPreloader } from '@ui/core'

type Props = {
  message?: string
}

defineProps<Props>()
</script>

<style>
.main-loader {
  @apply fixed inset-0;
  @apply bg-white dark:bg-gray-900;
  @apply bg-opacity-75;
  @apply z-30;
}
</style>
